// 执行全局初始化，然后动态导入并启动应用
async function startApp() {
    try {
        console.log("app starting...");

        // 1. 动态导入全局初始化模块并执行初始化
        const { initGlobalEnv } = await import("./app/global-init");
        await initGlobalEnv();
        console.log("init global env success.");

        // 2. 动态导入业务代码（确保在全局初始化完成后）
        const { launcher } = await import("./app/app");
        console.log("launcher loaded.");

        // 3. 启动应用
        await launcher.init();
        console.log("launcher inited.");

        await launcher.mounted();
        console.log("launcher mounted.");

        console.log("app started");
    } catch (error) {
        console.error("startApp error:", error);
        
        // 如果是动态导入失败（通常是版本更新导致文件404），自动刷新页面
        if (error instanceof TypeError && 
            error.message.includes('Failed to fetch dynamically imported module')) {
            console.warn("动态模块加载失败，可能是新版本部署，正在刷新页面...");
            
            // 避免无限刷新：检查是否刚刚刷新过（5秒内）
            const lastRefresh = sessionStorage.getItem('app-last-refresh');
            const now = Date.now();
            
            if (!lastRefresh || now - parseInt(lastRefresh) > 5000) {
                sessionStorage.setItem('app-last-refresh', now.toString());
                window.location.reload();
                return;
            } else {
                console.error("刷新页面后仍然失败，请检查网络连接或清除浏览器缓存");
            }
        }
        
        throw error;
    }
}

// 启动应用
startApp();
